import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RuntimeEnvService } from './runtime-env.service';

@Injectable({
  providedIn: 'root'
})
export class AgoraSimulatorService {

  constructor(
    private http: HttpClient,
    private runtimeEnv: RuntimeEnvService,
  ) { }

  private get baseUrl(): string {
    return this.runtimeEnv.url('SIMULADOR_AGORA');
  }

  getPendingProcess(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const url = `${this.baseUrl}/queue`;
    return this.http.get<any>(url, httpOptions);
  }

  actionOnProcess(identifier: string, action: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const url = `${this.baseUrl}/queue/${identifier}?action=${action}`;
    return this.http.post<any>(url, null, httpOptions);
  }
}
